<script>
  import InlineSvg from './InlineSvg.svelte';
</script>

<div class="card-container">
  <div class="category">
    <slot name="category" />
  </div>
  <div class="title">
    <slot name="title" />
  </div>
  <div class="description">
    <slot name="description" />
  </div>
  <slot name="image" />
</div>

<style lang="scss">
  @import '../../styles/mixins';

  .card-container {
    position: relative;
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    padding: 32px 16px 0;
    background: var(--color-blue-gray--100);
    box-shadow: 0px 20px 56px rgb(65 61 146 / 10%), 0px 6px 20px rgb(6 6 19 / 20%);
    border-radius: 8px;

    .title {
      font-size: 20px;
      line-height: 130%;
      color: var(--color-blue-gray--800);
      padding: 0 4px;
      margin-bottom: 4px;
    }

    .description {
      font-size: 14px;
      line-height: 140%;
      color: var(--color-blue-gray--500);
      padding: 0 4px;
      margin-bottom: 24px;
    }

    .category {
      position: absolute;
      top: 8px;
      right: 8px;
      font-size: 11px;
      line-height: 145%;
      padding: 2px 8px;
      color: var(--color-blue-gray--500);
      background-color: var(--color-blue-gray--150);
      border-radius: 5px;
    }
  }

  :global(.dark-mode) {
    .card-container {
      background: var(--color-blue-gray--800);
      box-shadow: 0px 20px 56px rgba(47, 45, 94, 0.06),
        0px 6px 20px rgba(47, 45, 94, 0.06);

      .title {
        color: var(--color-blue-gray--100);
      }

      .description {
        color: var(--color-blue-gray--200);
      }

      .category {
        color: var(--color-blue-gray--200);
        background-color: var(--color-blue-gray--600);
      }
    }
  }
</style>
